export default __webpack_public_path__ + "static/media/seven.fe8149e0.ogg";